import cmp from './ResetPassword'

export default cmp
